import { Link as ReactLink } from 'react-router-dom'

import {
  Drawer,
  Image,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Link as ChakraLink,
  useBreakpointValue,
  Box
} from '@chakra-ui/react'

import logo from '../../assets/img/logo.svg'
import { useSidebarDrawer } from '../../hooks/useSideBarDrawer'
import { SidebarNav } from './SidebarNav'

export function SideBar(): JSX.Element {
  const { isOpen, onClose } = useSidebarDrawer()
  const isDrawerSidebar = useBreakpointValue({
    base: true,
    lg: false
  })

  if (isDrawerSidebar) {
    return (
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay>
          <DrawerContent bg="gray.700" color="white">
            <DrawerCloseButton mt="6" />
            <DrawerHeader>Navegação</DrawerHeader>
            <DrawerBody p="0">
              <SidebarNav />
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    )
  }
  return (
    <Box
      as="aside"
      w="56"
      h="full"
      py="4"
      bg="gray.700"
      color="white"
      position="fixed"
      top="0"
      left="0"
      boxShadow="md"
      borderTopRightRadius="48px"
      borderBottomRightRadius="48px"
    >
      <ChakraLink as={ReactLink} to="/home" d="inline-block" ml="16px">
        <Image src={logo} alt="logo" w="150px" />
      </ChakraLink>
      <SidebarNav />
    </Box>
  )
}
